<template>
  <div class="apps-mini-list">
    <appStartModal
      ref="appStartModalRef"
      :appName="selectedAppName"
      :defaultValues="selectedDefaultValues"
      @job_started="jobStartedHandler"
    />

    <div v-if="apps && apps.length > 0" class="apps-mini-list__container">
      <AppMiniCard
        v-for="app in apps"
        :key="app.name"
        :name="app.name"
        :title="app.title"
        :description="app.description"
        :defaultValues="defaultValues"
        @app_selected="jobSelectedHandler"
      />
    </div>

    <div v-else class="apps-mini-list__empty">
      <p>No apps available</p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import AppMiniCard from '@/components/Apps/AppMiniCard.vue';
import appStartModal from '@/components/Apps/AppStartModal.vue';

const $toast = useToast();
const dataConnect = new DatastoreConnect();

const props = defineProps({
  type: {
    type: String,
    required: true,
  },
  defaultValues: {
    type: Object,
    default: () => ({}),
  },
});

const appStartModalRef = ref(null);
const selectedAppName = ref('');
const selectedDefaultValues = ref({});
const apps = ref(null);
const loading = ref(false);

onMounted(async () => {
  await fetchApps();
});

watch(() => props.type, async () => {
  await fetchApps();
});

async function fetchApps() {
  loading.value = true;
  try {
    const filter = { filter: { type: props.type } };
    const response = await dataConnect.api('app.list', filter);

    if (response.result) {
      apps.value = response.result;
    }

    if (response.error) {
      $toast.open({
        queue: true,
        duration: 5000,
        message: response.error.message,
        type: 'error',
        position: 'top',
      });
    }
  } catch (error) {
    console.log(error);
    $toast.open({
      queue: true,
      duration: 5000,
      message: 'Failed to load apps',
      type: 'error',
      position: 'top',
    });
  } finally {
    loading.value = false;
  }
}

function jobStartedHandler() {
  // Handle job started event
}

function jobSelectedHandler(payload) {
  selectedAppName.value = payload.name;
  selectedDefaultValues.value = payload.defaultValues || {};
  appStartModalRef.value.showModal();
}
</script>

<style lang="scss" scoped>
.apps-mini-list {
  &__container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 16px;
    padding: 16px;
  }

  &__empty {
    padding: 32px 16px;
    text-align: center;
    color: #666666;
  }
}
</style>
